import { Form, Button, Card, Checkbox, Spin } from "antd";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { current, firebaseEmailSignin, signOut } from "../../lib/auth/actions";
import styles from './auth.module.css'
import { win } from "../../lib/utils";
import { VerifyEmailForm } from "../../components/features/auth/VerifyEmailForm";
import { create } from "../../lib/user/actions";
import { VerifiedPasswordFormInputs } from "../../components/features/auth/PasswordForm";
import { ProfileFormInputs } from "../../components/features/auth/ProfileForm";
import Link from "next/link";

const [fbUser, signinProgress] = firebaseEmailSignin();

const NewUserForm = () => {
    const [user, progress] = create();
    const [currUser, currUserProgress] = current();

    const onFinish = (form: { email: string }) => {
        const email = win.localStorage?.setItem('emailForSignIn', form.email);
        progress.value.exec(form);
        // fb.requestEmailAuthCode(form);
    };
  

    const router = useRouter();

    useEffect(() => {
        if (user.value?.id) {
            setTimeout(() => {
                router.push("/auth");
            }, 5000)
        }
    }, [user.value?.id, router]);

    const fbuid = fbUser.value?.uid;
    useEffect(() => {
        if (fbuid)
            currUserProgress.value.exec();
    }, [currUserProgress, fbuid])

    if (progress.value.paused && user.value?.id)
        return <><h2>Success!</h2>
        <h3>Welcome to WebSemaphore</h3>
        Redirecting you to the <Link href="/auth">sign in</Link> page in a few seconds</>

    if (progress.value.inProgress)
        return <Spin />;

    return <div>
        {/* {JSON.stringify(currUser)} */}
        <Form layout="vertical" onFinish={onFinish}>
            <ProfileFormInputs />
            <VerifiedPasswordFormInputs newPassPropName="password" />


            <Form.Item
                name="criticalInfoConsent"
                valuePropName="checked"
                rules={[
                    {
                        validator: (_, value) =>
                            value ? Promise.resolve() : Promise.reject(new Error('Please agree to receive critical updates')),
                    },
                ]}
            >
                <Checkbox>
                    I consent to receive critical updates (no spam!)
                </Checkbox>
            </Form.Item>

            <br /><br />
            <Form.Item
                name="newsConsent"
                valuePropName="checked"
            >
                <Checkbox>
                    I consent to receive product/company related news and updates (no spam!)
                </Checkbox>
            </Form.Item>

            <Form.Item>
                <div className="footer">
                    <Button onClick={() => signOut()}>
                        Cancel
                    </Button>
                    <Button type="primary" htmlType="submit">
                        Create Account
                    </Button>
                </div>
            </Form.Item>
        </Form>
    </div>
}

const SignupForm = () => {
    // const [fbUser, progress] = firebaseEmailSignup();
    const [currUser, currUserProgress] = current();
    const [signingOut, setSigningOut] = useState(false)
    const router = useRouter();

    const isKnown = fbUser.value?.uid && currUser?.id;
    
    useEffect(() => {
        if (isKnown) {
            signOut({ route: "/auth", delay: 5000 });
            setSigningOut(true)
        } else
            if (currUser?.id)
                router.push("/console")
    }, [isKnown, currUser, router]);

    if (isKnown || signingOut)
        return <><h2>You are already signed up to WebSemaphore.</h2>
            To reset your password, click <Link href="/recover-password">Forgot password</Link> on the signin page.
            <br /><br />
            You will now be redirected to the <Link href="/auth">signin</Link> page.
        </>

    return (
        fbUser.value ?
            <NewUserForm /> :
            <VerifyEmailForm actionPath="/auth/signup" />
    );
};

const Page = () => {
    return <div  className={styles.auth}><Card title="Sign up"><SignupForm /></Card></div>
}

export default Page;